import React from "react";
import './MahutiInputVisitors.css'
function MahutiInputVisitors(props) {
    
    const onCustomerChange = (num) => {
        props.setVisitorsNumber(num);
    }

    return <div className="alef info_block py-lg-4 py-1 border border-end-0 border-start-0 border-top-0">
        <div className="mahutiInputVisitors row align-items-center">
            <div className="col-lg-4 col header-detail text-start">
                {props.visitor}
            </div>
            <div className="col-lg-3 col middle">
                {props.price ? `${props.price}₪` : ''}
            </div>
            <div className="col-lg-5 col-7">
                <div className="bd-highlight ">
                    <div className="btn-group align-items-center justify-content-end d-flex">
                        <button 
                            className="sign-btn plus d-flex justify-content-center align-items-center" 
                            onClick={() => onCustomerChange(props.visitorsNumber + 1)} 
                            disabled={props.disabled}
                            aria-label={`הוסף כרטיס ל${props.visitor}`}>
                            <span className="plus" aria-hidden="true">
                                +
                            </span>
                        </button>

                        {/* Current number announcement for screen readers */}
                        <div className="sr-only" role="status" aria-live="polite">
                            {`${props.visitorsNumber} כרטיסים ל${props.visitor}`}
                        </div>

                        {/* Visual representation of the number */}
                        <div className="input-number d-flex" 
                             style={{minWidth: '17px'}}
                             aria-hidden="true">
                            {props.visitorsNumber}
                        </div>

                        <button 
                            className="sign-btn minus d-flex justify-content-center align-items-center" 
                            onClick={() => onCustomerChange(props.visitorsNumber - 1)} 
                            disabled={props.isInternal ? props.visitorsNumber === 0 : props.visitorsNumber === 1}
                            aria-label={`הסר כרטיס ל${props.visitor}`}>
                            <span className="minus" aria-hidden="true">
                                -
                            </span>
                        </button>
                    </div>
                </div>
            </div>
        </div>

    </div>
}

export default MahutiInputVisitors;